<div class="app-shell">

  <!-- ╔══════════════ NAVBAR ══════════════╗ -->
  <nav class="navbar">
    <div class="nav-inner">
      
      <div class="logo" (click)="navigate('home')">
        🐾 CON<span class="logo-vs">-</span>KAN
      </div>

      <!-- Hamburger -->
      <button class="hamburger" (click)="toggleMenu()"
              [class.open]="menuOpen" aria-label="Menu">
        <span></span><span></span><span></span>
      </button>

      <!-- Links -->
      <ul class="nav-links" [class.nav-open]="menuOpen">

        <li>
          <button class="nav-btn"
                  [class.active]="activePage === 'test'"
                  (click)="navigate('test')">
            <i class="fa-solid fa-flask"></i> Test The Model
          </button>
        </li>

        <li>
          <a class="nav-btn"
             href="https://b-spline-site.onrender.com/bspline.html"
             target="_blank" rel="noopener">
            <i class="fa-solid fa-bezier-curve"></i> Explore Spline
          </a>
        </li>

        <li>
          <button class="nav-btn"
                  [class.active]="activePage === 'kan'"
                  (click)="navigate('kan')">
           <i style="font-size: larger;" class="fa-solid fa-hexagon-nodes"></i> Know KAN
          </button>
        </li>

        <li>
          <button class="nav-btn"
                  [class.active]="activePage === 'cnn'"
                  (click)="navigate('cnn')">
            <i style="font-size: larger;" class="fa-solid fa-eye"></i>About CNN
          </button>
        </li>

        

        <li>
          <a class="nav-btn link-external"
             href="https://github.com/Abhiraj-Sardar/CON-KAN"
             target="_blank" rel="noopener">
            <i style="font-size: larger;" class="fa-brands fa-github"></i> GitHub
          </a>
        </li>

        

      </ul>

      
      <!-- From Uiverse.io by RiccardoRapelli --> 
<label class="switch">
  <input (click)="changeMode()" id="input" type="checkbox" />
  <div class="slider round">
    <div class="sun-moon">
      <svg id="moon-dot-1" class="moon-dot" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="moon-dot-2" class="moon-dot" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="moon-dot-3" class="moon-dot" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="light-ray-1" class="light-ray" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="light-ray-2" class="light-ray" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="light-ray-3" class="light-ray" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>

      <svg id="cloud-1" class="cloud-dark" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="cloud-2" class="cloud-dark" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="cloud-3" class="cloud-dark" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="cloud-4" class="cloud-light" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="cloud-5" class="cloud-light" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
      <svg id="cloud-6" class="cloud-light" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="50"></circle>
      </svg>
    </div>
    <div class="stars">
      <svg id="star-1" class="star" viewBox="0 0 20 20">
        <path
          d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"
        ></path>
      </svg>
      <svg id="star-2" class="star" viewBox="0 0 20 20">
        <path
          d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"
        ></path>
      </svg>
      <svg id="star-3" class="star" viewBox="0 0 20 20">
        <path
          d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"
        ></path>
      </svg>
      <svg id="star-4" class="star" viewBox="0 0 20 20">
        <path
          d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"
        ></path>
      </svg>
    </div>
  </div>
</label>
      

    </div>
  </nav>
  <!-- ╚════════════════════════════════════╝ -->

  <!-- ╔══════════════ CONTENT ══════════════╗ -->
  <main class="main-content">
    <app-home        *ngIf="activePage === 'home'" class="page-enter"></app-home>
    <app-test-model  *ngIf="activePage === 'test'" class="page-enter"></app-test-model>
    <app-know-kan    *ngIf="activePage === 'kan'"  class="page-enter"></app-know-kan>
    <app-about-cnn   *ngIf="activePage === 'cnn'"  class="page-enter"></app-about-cnn>
  </main>
  <!-- ╚════════════════════════════════════╝ -->

  <!-- ╔══════════════ FOOTER ══════════════╗ -->
  <footer class="footer">
    <p>🐾 CON - KAN Explorer &copy; 2026 &nbsp;|&nbsp; Built with ❤️ &amp; Angular 13</p>
  </footer>
  <!-- ╚════════════════════════════════════╝ -->

</div>